import { render, staticRenderFns } from "./privacyPolicyEditor.vue?vue&type=template&id=1647c081&scoped=true"
import script from "./privacyPolicyEditor.vue?vue&type=script&lang=js"
export * from "./privacyPolicyEditor.vue?vue&type=script&lang=js"
import style0 from "./privacyPolicyEditor.vue?vue&type=style&index=0&id=1647c081&prod&scoped=true&lang=css"
import style1 from "./privacyPolicyEditor.vue?vue&type=style&index=1&id=1647c081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647c081",
  null
  
)

export default component.exports